export const
    openCodeStr = 'open-code',
    getObject = 'code-editor-object',
    getConstuctor = 'code-editor-constructor';
